var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 18,
    viewBox: "0 0 13.5 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-map-marker-alt",
    "data-name": "Icon awesome-map-marker-alt",
    d: "M6.056,17.637C.948,10.232,0,9.472,0,6.75a6.75,6.75,0,1,1,13.5,0c0,2.722-.948,3.482-6.056,10.887a.844.844,0,0,1-1.387,0ZM6.75,9.562A2.812,2.812,0,1,0,3.937,6.75,2.812,2.812,0,0,0,6.75,9.562Z",
    fill: "#716f6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinSvg);
export default __webpack_public_path__ + "static/media/location-pin-svg.b3942a9bcb8daaf5c0d906782f7596d7.svg";
export { ForwardRef as ReactComponent };